import classNames from "classnames";
import React, { useCallback, useMemo } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { useAppDispatch } from "../../../../../state/store";
import { disableAlertsAction, toggleAllCheckAlertsAction } from "../../../../../state/usecase/admin/care_recipient/actions";
import useAlerts from "../../../../hooks/admin/care_recipient/useAlerts";
import { useBoolean } from "../../../../hooks/common/useBoolean";
import { SubButton } from "../../../common/button/SubButton";
import { InputCheckBox } from "../../../common/input/InputCheckBox";
import { DropDownIcon } from "../../../header/icons/DropDownIcon";

export const AlertsTableHead = React.memo(function AlertsTableHead() {
    const dispatch = useAppDispatch();

    const { alerts, checkedAlertIds } = useAlerts();

    const alertIdList = useMemo(() => alerts?.map(alert => alert.alert.id) ?? [], [alerts]);

    const allChecked = useMemo(() => checkedAlertIds.length === alertIdList.length, [checkedAlertIds, alertIdList]);

    const [openCheckedOperations, , closeCheckedOperations, toggleOpenCheckedOperations] = useBoolean();

    const handleCheckBoxChanged = useCallback((check: boolean) => {
        dispatch(toggleAllCheckAlertsAction({ check: check }));
    }, [dispatch]);

    const doneCheckedAlert = useCallback(() => {
        closeCheckedOperations();

        const confirm = window.confirm(`${checkedAlertIds.length}件のアラートを解除します。よろしいですか？`);

        if (!confirm) return;

        dispatch(disableAlertsAction({ alertIdList: checkedAlertIds }));
    }, [closeCheckedOperations, checkedAlertIds, dispatch]);

    return (
        <thead>
            <tr className={"header"}>
                <th>
                    <OutsideClickHandler onOutsideClick={closeCheckedOperations}>
                        <div className="allCheck">
                            <InputCheckBox label={""} checked={allChecked} handleCheckBoxChanged={handleCheckBoxChanged}/>
                            <button onClick={toggleOpenCheckedOperations}>
                                <DropDownIcon />
                            </button>
                        </div>
                        <div className={classNames("checked_operations", { "checked_operations_open": openCheckedOperations })}>
                            <div>
                                <SubButton disabled={checkedAlertIds.length < 1} onClick={doneCheckedAlert}>解除</SubButton>
                            </div>
                        </div>
                    </OutsideClickHandler>
                </th>
                <th>ハウスID</th>
                <th>氏名</th>
                <th>
                    <p>データ連携開始日時</p>
                    <p>平均値期間設定</p>
                    <p>データ連携終了日時</p>
                </th>
                <th>アラート</th>
                <th></th>
                <th>グラフ表示</th>
            </tr>
        </thead>
    );
});